<app-file-drop (fileDrop)="dropped($event)" (fileOver)="fileOver($event)" (fileLeave)="fileLeave($event)" class="ols-filedrop" [ngClass]="{'ols-files': isFilesUpload}">
  <div class="ols-upload-container" [ngClass]="{'hovered' : isHovered, 'filesAdded' : isMobileView() && resultaat.uploadedFiles.length > 0}">
    <div *ngIf="(resultaat != null) && (resultaat.uploadedFiles.length < maxFiles)" class="upload">
      <input [accept]="inputAllowExtensions" type="file" #newFile name="newfile{{vraag.id}}" (change)="onFileChanged($event)" id="newfile{{vraag.id}}" class="inputfile" multiple />
      <ng-container for="newfile{{vraag.id}}" *ngIf="isMobileView(); then mobileBlock else desktopBlock"></ng-container>
      <ng-template #mobileBlock>
        <label for="newfile{{vraag.id}}" [id]="geefMeetidFile()">
          <div class="ols-cross-ph">
            <div class="ols-cross"></div>
          </div>
          <span *ngIf="resultaat == null || resultaat.uploadedFiles.length == 0">Voeg maximaal {{maxFiles}} bestanden toe van in totaal {{maxTotalSizeInMb}}MB.</span>
          <br>
          <ng-container *ngIf="resultaat?.uploadedFiles?.length > 0">
            <br>
          </ng-container>
          <span>We accepteren bestandstypes: {{labelAllowExtensions}}</span>
        </label>
      </ng-template>
      <ng-template #desktopBlock>
        <label for="newfile{{vraag.id}}" [id]="geefMeetidFile()">
          <div class="ols-cross-ph">
            <div class="ols-cross"></div>
          </div>
          <span>Voeg hier maximaal {{maxFiles}} bestanden toe van in totaal {{maxTotalSizeInMb}}MB.</span><br>
          <span>We accepteren bestandstypes: {{labelAllowExtensions}}</span>
        </label>
      </ng-template>
    </div>
    <div *ngIf="(resultaat != null) && (resultaat.uploadedFiles.length >= maxFiles)" class="upload-message">
      Het is niet meer mogelijk om extra bestanden toe te voegen. Het is toegestaan om maximaal {{maxFiles}} bestanden toe te voegen.
    </div>
  </div>
</app-file-drop>
<div *ngIf="resultaat && isFilesUpload" data-hj-suppress class="uploadfiles-container">
  <div *ngFor="let file of resultaat.uploadedFiles; let fileIndex = index" class="uploadfile file">
    <div class="thumbnail_filename">
      <div class="thumbnail" [ngClass]="{'doc' : !isFileImage(file.name)}">
        <img *ngIf="!isFileImage(file.name)" src="/assets/icons/ols/document.svg" />
        <img *ngIf="isFileImage(file.name)" [src]="file.dataUrl | sanitizeUrl" />
      </div>
      <div class="filename">{{file.name}}</div>
      <div class="delete" (click)="deleteFile(fileIndex)" [id]="geefMeetidIndex('verwijderen', fileIndex)">
        <img src="/assets/icons/ols/prullenbak.svg" />
      </div>
    </div>
  </div>
</div>
<div *ngIf="resultaat && !isFilesUpload" data-hj-suppress class="uploadimages-container">
  <div *ngFor="let file of resultaat.uploadedFiles; let fotoIndex = index" class="uploadimage file">
    <img [src]="file.dataUrl | sanitizeUrl" />
    <div class="overlayzoom" (click)="zoomImage(fotoIndex)" [id]="geefMeetidIndex('naar_fotoviewer', fotoIndex)">
      <div class="circlezoom"></div>
      <div class="zoom"></div>
    </div>
    <div class="ols-overlaydelete" (click)="deleteFile(fotoIndex)" [id]="geefMeetidIndex('verwijderen', fotoIndex)">
      <div class="circledelete"></div>
      <div class="delete"></div>
    </div>
  </div>
  <div *ngFor="let file of createRangeForFotosToUpload(); let fileIndex = index" class="uploadimage uploading">
    <div class='meldingpopup-loadingicon'>
      <img src="/assets/icons/ols/loading.gif" />
    </div>
    <div class="overlay"></div>
  </div>
</div>

<div *ngIf="indexImageToZoom >= 0" (click)="closeZoom()" data-hj-suppress class="modal is-shown ols-imagepopup" [id]="geefIpoView()">
  <div role="dialog document" arial-label="Controleer foto" class="modal__window">
    <focus-trap tabindex="0">
      <div class="modal__inner">
        <div class="modal__header">
          <h2 (click)="$event.stopPropagation()" class="modal__header-title">
            {{resultaat.uploadedFiles[indexImageToZoom].name}}</h2>
        </div>
        <div (click)="$event.stopPropagation()" class="modal__content">
          <img [src]="resultaat.uploadedFiles[indexImageToZoom].dataUrl | sanitizeUrl" />
          <div class="ols-overlaydelete" (click)="deleteFile(indexImageToZoom)"
            [id]="geefMeetid('fotoviewer_verwijderen')">
            <div class="circledelete"></div>
            <div class="delete"></div>
          </div>
          <div *ngIf="resultaat.uploadedFiles.length > 1" (click)="nextImageToZoom()" class="ols-overlaynext"
            [id]="geefMeetid('fotoviewer_volgende')"></div>
          <div *ngIf="resultaat.uploadedFiles.length > 1" (click)="prevImageToZoom()" class="ols-overlayprevious"
            [id]="geefMeetid('fotoviewer_vorige')"></div>
        </div>
        <div [id]="geefMeetid('fotoviewer_sluiten')" class="close-button" role="button" arial-label="Sluit venster">
        </div>
      </div>
    </focus-trap>
  </div>
</div>

<div *ngIf="indexFileToDelete > -1" class="modal is-shown ols-delete-popup">
  <div role="dialog document" arial-label="Verwijderen" class="modal__window">
    <focus-trap tabindex="0">
      <div class="modal__inner">
        <div class="modal__header">
          <h2 class="modal__header-title">{{labelVerwijderen}}</h2>
        </div>
        <div class="modal__content">
          <div class="ols-filename">{{deleteFilename}}</div>
          <div class="media__actions">
            <a class="button has-ripple" (click)="verwijderen()" [id]="geefMeetid('verwijderen_definitief')">Verwijderen</a>
            <a class="button-link" (click)="annuleerVerwijderen()" [id]="geefMeetid('verwijderen_annuleren')">Annuleren</a>
          </div>
        </div>
      </div>
    </focus-trap>
  </div>
</div>

<div *ngIf="errorMessage.length > 0" class="ols-error-container">
  <div *ngFor="let message of errorMessage" class="ols-error">
    {{message}}
  </div>
</div>
<p class="error-block" *ngIf="submitClicked && resultaat.uploadedFiles.length === 0">Voeg een document toe</p>